// authSaga.js
import axios from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { signUpSuccess, signInSuccess, signUpFailed, signInFailed } from '../reducers/authSlice';
import { UserLoginDto, UserSignUpDto } from '../../models/user.model';
import { apiEndpoints } from '../../utils/api-endpoints';
import { createErrorAction } from '../reducers/errorSlice';
import { getErrorMessage } from '../../utils/helper.utils';

function* signUpSaga({ payload }: { payload: UserSignUpDto }): any {
  try {
    const response = yield axios.post(apiEndpoints.auth.signup, payload);
    yield put(signUpSuccess(response.data));
  } catch (error) {
    yield put(createErrorAction(error, 'auth/signUp'));
    yield put(signUpFailed(getErrorMessage(error)));
  }
}

function* signInSaga({ payload }: { payload: UserLoginDto }): any {
  try {
    const response = yield axios.post(apiEndpoints.auth.signin, payload);
    yield put(signInSuccess(response.data));
  } catch (error) {
    yield put(createErrorAction(error, 'auth/signIn'));
    yield put(signInFailed(getErrorMessage(error)));
  }
}

export function* watchAuthSaga() {
  yield takeLatest('auth/signUp' as any, signUpSaga);
  yield takeLatest('auth/signIn' as any, signInSaga);
}